module.exports = __webpack_public_path__ + "img/rongYu4.e54315df.png";